import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import Pagination from 'react-js-pagination'

import AttractionActions from '../../Redux/AttractionRedux'
import MarkupActions from '../../Redux/MarkupRedux'

class FormCreate extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: false,
      selectedAttraction: {
        title: ''
      },
      form: {
        attraction_id: '',
        value: 0,
        test_value: 1
      },
      page: 1,
      search: ''
    }
  }

  componentDidMount = () => {
    const data = {
      q: this.state.search,
      page: this.state.page
    }
    this.props.search(data)
  }

  _toggleAttractionModal = () => {
    this.setState({ showModal: !this.state.showModal })
    if (this.state.showModal) {
      this.setState({ page: 1, search: '' })
      const data = {
        q: '',
        page: 1
      }
      this.props.search(data)
    }
  }

  _inputSearchChange = (event) => {
    const val = event.target.value
    this.setState({ search: val })
  }

  _search = (event) => {
    event.preventDefault()
    const data = {
      q: this.state.search,
      page: this.state.page
    }
    this.props.search(data)
  }

  _changePage = (page) => {
    this.setState({ page })

    const data = {
      q: this.state.search,
      page
    }
    this.props.search(data)
  }

  _selectAttraction = (data) => {
    this.setState({
      selectedAttraction: data,
      form: {
        ...this.state.form,
        attraction_id: data.id
      }
    })
    this._toggleAttractionModal()
  }

  _save = (event) => {
    event.preventDefault()
    const data = {
      ...this.state.form,
      value: (this.state.form.value / 100) + 1
    }
    this.props.createMarkup(data)
    this.props.closeModal()
  }

  _valueChange = (event) => {
    let val = event.target.value
    if (parseFloat(val) > 100) {
      val = 100
    } else if (parseFloat(val) < -100) {
      val = -100
    }
    let form = { ...this.state.form }
    form.value = val
    this.setState({ form })
  }

  render () {
    const { attraction } = this.props
    const { attraction_id } = this.state.form

    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Create New Markup</h4>
        </div>
        <form onSubmit={(event) => this._save(event)}>
          <div className='form-group'>
            <label className='control-label'>Attraction Title</label>
            <input role='button' type='text' className='form-control' readOnly value={this.state.selectedAttraction.title || '- Click to select -'} onClick={() => this._toggleAttractionModal()} />
          </div>
          <div className='form-group' style={{ width: '25%' }}>
            <label className='control-label'>Value</label>
            <div className='input-group' >
              <input type='number' required step='any' max={100} className='form-control' value={this.state.form.value} onChange={(event) => this._valueChange(event)} />
              <div className='input-group-append'>
                <span className='input-group-text'>%</span>
              </div>
            </div>
          </div>
          <div className='form-group text-right'>
            <button type='button' className='btn btn-secondary' onClick={() => this.props.closeModal()}>Cancel</button>
            <button type='submit' disabled={!attraction_id} className='btn btn-primary ml-2'>Save</button>
          </div>
        </form>

        {/* MODAL SELECT ATTRACTION */}
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal} closeOnOverlayClick onClose={() => this._toggleAttractionModal()}>
          <section className='section' style={{ width: '60vw' }}>
            <div className='titile-block mb-2'>
              <h4 className='title mr-auto'>Select Attraction</h4>
            </div>

            <form className='row mb-2' onSubmit={(event) => this._search(event)}>
              <div className='col-10'>
                <input type='search' name='search' className='form-control' placeholder='Search Attraction' onChange={(event) => this._inputSearchChange(event)} />
              </div>
              <div className='col-2'>
                <button className='btn btn-primary'>
                  <i className='fa fa-search' />
                </button>
              </div>
            </form>

            <section className='table-responsive'>
              <table className='table table-hover table-striped'>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Title</th>
                    <th>Provider</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  { !attraction.dataSearch.data || !attraction.dataSearch.data.length
                    ? <tr>
                      <td colSpan='3' className='text-center'>- No Data -</td>
                    </tr>
                    : attraction.dataSearch.data.map((item, i) => (
                      <tr key={i}>
                        <td>{ (i + 1) + ((this.state.page - 1) * 10) }</td>
                        <td>{ item.title }</td>
                        <td>{ item.provider }</td>
                        <td>
                          <button onClick={() => this._selectAttraction(item)} className='btn btn-info'>Select</button>
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </section>

            <section className='text-center'>
              {
                attraction.dataSearch.total &&
                <Pagination
                  innerClass='pagination'
                  itemClass='page-item'
                  linkClass='page-link'
                  activePage={attraction.dataSearch.page || this.state.page}
                  itemsCountPerPage={10}
                  totalItemsCount={attraction.dataSearch.total}
                  pageRangeDisplayed={5}
                  onChange={this._changePage}
                />
              }
            </section>

          </section>
        </Modal>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  attraction: state.attraction
})

const dispatchToProps = (dispatch) => ({
  search: (data) => dispatch(AttractionActions.attractionSearchRequest(data)),
  createMarkup: (data) => dispatch(MarkupActions.markupCreateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(FormCreate)



// WEBPACK FOOTER //
// ./src/Containers/Markup/FormCreate.js